import { render } from "./Hem.vue?vue&type=template&id=1028bb44"
import script from "./Hem.vue?vue&type=script&lang=js"
export * from "./Hem.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__